import { Card } from '@/components/atoms/Card';
import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';

import styles from './PenOverviewCard.module.scss';

const METRIC_KEYS = ['weight', 'lice', 'depth', 'lux', 'pitch', 'roll'];

export default function PenOverviewCardSkeleton() {
    return (
        <Card radius="sm" className={styles.card}>
            <div className={styles.header}>
                <SkeletonBox width={80} height={20} />
                <SkeletonBox width={70} height={20} borderRadius={999} />
            </div>
            <div className={styles.metricsRow}>
                {METRIC_KEYS.map((key) => (
                    <SkeletonBox key={key} width={40} height={20} />
                ))}
            </div>
            <div className={styles.separator} />
            <div className={styles.bioscopeFooter}>
                <div className={styles.lastMeasurementBlock}>
                    <SkeletonBox width={100} height={20} />
                    <SkeletonBox width={140} height={22} />
                </div>
                <SkeletonBox width={100} height={30} />
            </div>
        </Card>
    );
}
